import React from "react";
import { apiPath } from "../utilities/Constants";
import useFetch from "../hooks/useFetch";
import GlobalForm from "../components/globalForm/GlobalForm";
import { updateData } from "../hooks/update";
import Loader from "../components/shared/Loader/Loader";
import LoaderFilling from "../components/shared/Loader/LoaderFilling";

function WhyUsPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { learnTitle, learnDetails, _id } = apiData[0] ?? {};

  // Form data
  const data = [
    {
      elementType: "input",
      label: "Why us section title",
      type: "Text",
      name: "learnTitle",
      defaultValue: learnTitle,
      required: false,
    },
    {
      elementType: "textField",
      label: "Why us section description",
      type: "Text",
      name: "learnDetails",
      defaultValue: learnDetails,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(homeApi, data, _id);
  };

  return <div>{_id && <GlobalForm data={data} update={update} />}</div>;
}

export default WhyUsPage;
